import { type PostDto } from '../model/contracts'

export function getAuthorParts(author: PostDto['author']): {
  name: string
  handleLabel?: string
  verified: boolean
} {
  return {
    name: author.name,
    handleLabel: author.handle ? `@${author.handle}` : undefined,
    verified: Boolean(author.verified),
  }
}

export function getContextLabels(context: PostDto['context']): string[] {
  const out: string[] = []
  if (context.isReply) out.push('Reply')
  if (context.isRetweet) out.push('Repost')
  return out
}
